import { firstValueFrom } from 'rxjs';
import { MpsUserService } from '../services/mps-user.service';
import { MpsOauth2Service } from '../services/mps-oauth2.service';
import { MpsUser } from '../../app/models/mps-user.model';

export function mpsFetchBearer(oauth2service: MpsOauth2Service, userService: MpsUserService) {
  return (): void | Promise<MpsUser> => {
    const url = new URL(window.location.href);
    const id = url.searchParams.get('_et');

    if (id) {
      return firstValueFrom(oauth2service.fetchToken(id)).then((response: { token: string }) => {
        localStorage.setItem('token', response.token);
        return firstValueFrom(userService.fetchUser());
      });
    }
  };
}
